import { AxiosRequestConfig } from 'axios'

export interface GenderAnalysisByLevelDetailedParams {
  startDate: string
  endDate: string
  storeId?: number
}

export interface GenderData {
  level: number
  code: string
  name: string
  value: number
}

export const getGenderAnalysisByLevelDetailed = (
  params: GenderAnalysisByLevelDetailedParams,
): AxiosRequestConfig => ({
  url: '/dashboard/gender-analysis-by-level-detailed',
  method: 'GET',
  params,
})
